module.exports = __webpack_public_path__ + "img/template.44359226.jpg";